/**
 * Application Constants
 */

import { config } from "@/config/env";

// Usar getter para lazy loading do config
export const API_CONFIG = {
  get BASE_URL() {
    return config.backendBaseUrl;
  },
  TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3,
} as const;

export const STORAGE_KEYS = {
  SESSION_TOKEN: "session_token",
  USER_DATA: "user_data",
  REDUX_PERSIST: "persist:root",
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;
